import React, { useEffect, useState } from "react";

const fmtT = new Intl.DateTimeFormat("en-US", { timeZone: "America/Chicago", hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true });
const fmtD = new Intl.DateTimeFormat("en-US", { timeZone: "America/Chicago", weekday: "short", month: "short", day: "numeric", year: "numeric" });

export const LiveClock = ({ className = "", big = false }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return (
    <div className={`nx-mono text-right leading-tight ${className}`} data-testid="live-clock">
      <p className={`font-bold text-[#00F0FF] tabular-nums ${big ? "text-2xl" : "text-xs"}`} style={{ textShadow: "0 0 10px #00F0FF66" }} data-testid="live-clock-time">{fmtT.format(now)} CT</p>
      <p className={`text-cyan-100/50 ${big ? "text-sm" : "text-[10px]"}`} data-testid="live-clock-date">{fmtD.format(now)}</p>
    </div>
  );
};
